import { ECategory, EDealType, EOfferType } from 'shared/types/offers';

export const isDailyRent = (category: ECategory): boolean => {
  return Boolean(category && category.indexOf('daily') !== -1);
};

export const isRent = (dealType?: EDealType): boolean => {
  return Boolean(dealType && dealType.indexOf('rent') !== -1);
};

export const isSuburban = (category: ECategory): boolean => {
  return category
    ? [
        'cottageRent',
        'cottageSale',
        'dailyHouseRent',
        'houseRent',
        'houseSale',
        'houseShareRent',
        'houseShareSale',
        'landRent',
        'landSale',
        'townhouseRent',
        'townhouseSale',
      ].includes(category)
    : false;
};

export const isResidential = (category: ECategory): boolean => {
  return category
    ? [
        'dailyFlatRent',
        'dailyHouseRent',
        'dailyRoomRent',
        'cottageRent',
        'cottageSale',
        'flatRent',
        'flatSale',
        'flatShareSale',
        'houseRent',
        'houseSale',
        'houseShareRent',
        'houseShareSale',
        'newBuildingFlatSale',
        'roomRent',
        'roomSale',
        'townhouseSale',
        'townhouseRent',
        'landRent',
        'landSale',
      ].includes(category)
    : false;
};

export const isCommercial = (offerType?: EOfferType) => {
  return offerType === 'commercial';
};

export const isFlat = (offerType?: EOfferType): boolean => {
  return offerType === 'flat';
};

export const isRoom = (category: ECategory): boolean => {
  return category === 'roomRent' || category === 'roomSale' || category === 'dailyRoomRent';
};

export const isFlatShared = (category: ECategory): boolean => {
  return category === 'flatShareSale';
};

export const isGarage = (category: ECategory): boolean => {
  return category === 'garageSale' || category === 'garageRent';
};

export const isCommercialLand = (category: ECategory) => {
  return category && ['commercialLandRent', 'commercialLandSale'].includes(category);
};

export const isNewbuilding = (category: ECategory): boolean => {
  return category === 'newBuildingFlatSale';
};
